import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UsuarioService, GralUsrDto } from '../usuario.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
import {PaginadorService, PageBusquedaObject} from '../../../paginador/paginador.service';
@Component({
  templateUrl: './catalogo-usuario.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./catalogo-usuario.component.css'],
  preserveWhitespaces: true
})
export class CatalogoUsuarioComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: GralUsrDto[];
  cargado: boolean;
  titulo_paginador = 'usuario-paginador';
  constructor(private paginadorService: PaginadorService, public service: UsuarioService, public loginService: LoginService) {
  }

  ngOnInit(): void {
    this.busqueda = this.paginadorService.getBusquedaCatalogo(this.titulo_paginador);
    this.cargarCatalogo();
  }
  cargarCatalogo() {
    this.mostrarMensajeCarga();
    this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.service.gralUsrCatalogoUsingPOST(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
      this.cerrarMensajeCarga();
      this.paginadorService.setBusquedaCatalogo(this.titulo_paginador,this.busqueda);
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 1;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.cargarCatalogo();
  }
  eliminar(dtoEliminar: GralUsrDto): void {
    Swal.fire({
      title: 'TNK Ledger',
      text: `¿Está seguro de inhabilitar al usuario?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.service.deleteUserUsingDELETE(dtoEliminar.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
